import { render, staticRenderFns } from "./PenyebranganEdit.vue?vue&type=template&id=948e6afc&scoped=true"
import script from "./PenyebranganEdit.vue?vue&type=script&lang=js"
export * from "./PenyebranganEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948e6afc",
  null
  
)

export default component.exports